module.exports = __webpack_public_path__ + "img/ss.d9d679e1.png";